import * as React from 'react'
import StandardInput from '../../common/components/standard-input'
import Validation from '../../common/modules/validation/rules'
import Recaptcha from '../../common/components/recaptcha'
import CheckboxInput from '../../common/components/checkbox-input'
import StepTitle from '../../common/components/step-title'
import StepBlock from '../../common/components/step-block'
import QuoteNumber from '../../common/components/quote-number'
import SubHeader from '../../common/components/sub-header'
import InputField from '../../common/components/input-field'
import SuburbAutoComplete from '../../common/components/suburb-auto-complete'
import Button from '../../common/components/button'
import QueryString from 'query-string'
import checkOptions from '../../common/options/check-options'
import { getQueryString } from '../../common/util'
import { withSubmission } from '../../common/modules/submission'
import { withForm } from '../../common/modules/form'
import { withConfig } from  '../../common/modules/config'
import { withErrors } from  '../../common/modules/errors'
import { withFields } from  '../../common/modules/fields'
import { withRouteBlocker } from '../../common/modules/route-blocker'
import { withValidation } from  '../../common/modules/validation'
import { withNavigation } from  '../../common/modules/navigation'
import { withScrollToTop } from '../../common/modules/scroll-to-top'


export const formConfig = state => {
    const fields = state.fields;

    return {
        rules: {
            "firstName":[
                Validation.enforce.required("Please enter a first name")
            ],
            "surname":[
                Validation.enforce.required("Please enter a surname")
            ],
            "email":[
                Validation.enforce.required("Please provide a valid email"),
                Validation.enforce.email("Must be a valid email")
            ],
            "phone":[
                Validation.enforce.required("Please provide a valid phone number"),
            ],
            "postalAddress":[
                Validation.enforce.required("Please provide the billing address"),
            ],
            "suburb":[
                Validation.enforce.required("Please provide the suburb"),
            ],
            "postcode":[
                Validation.enforce.required("Please provide the postcode")
            ],
            "state":[
                Validation.enforce.required("Please provide the state"),
            ],
        },
        predicates:{},
        options:{
            useExistingAddress: checkOptions
        },
        inferred:{},
        transformOut: data => data
    }

}


@withSubmission
@withConfig
@withErrors
@withFields
@withValidation
@withNavigation
@withRouteBlocker
@withScrollToTop
@withForm( formConfig )
export default class extends React.Component<any, any> {

    private savedAddress = {
        postalAddress:"",
        suburb:"",
        state:"",
        postcode:""
    }

    
    componentWillMount(){
        const fields = this.props.fields;
        if(fields.useExistingAddress == null || fields.useExistingAddress == true){
            var address = fields.unit ? fields.unit : "";
            if(fields.unit && fields.streetNumber) address += "/";
            if(fields.streetNumber) address += fields.streetNumber;
            if(fields.streetName) address += " " + fields.streetName;
            this.props.actions.fields.updateField("postalAddress", address);
            this.props.actions.fields.updateField("useExistingAddress", true);
        }
    }



    intercept(field, value){
        const fields = this.props.fields;
        switch(field){
            case "useExistingAddress":
                const currentAddress = {
                    postalAddress: fields.postalAddress,
                    suburb: fields.suburb,
                    state: fields.state,
                    postcode: fields.postcode
                }
                this.props.actions.fields.updateFields(this.savedAddress)
                this.savedAddress = currentAddress;
            break;
        }
        return value;
    }
    

    render() {
        const fields = this.props.fields

        return (   
            <div className="row">
                <StepBlock><h4>We need a few additional details to complete your policy</h4></StepBlock>
                <StepTitle>Contact information</StepTitle>	
                <QuoteNumber />

                <InputField field="firstName"               label="First Name"  />
                <InputField field="surname"                 label="Surname"     />
                <InputField field="phone"     type="tel"    label="Phone"       />
                <InputField field="email"     type="email"  label="Email"       />

                <SubHeader>Billing address</SubHeader>
                <StepBlock>We will try to get you your documents via email, however just in case, please tell me your billing address.</StepBlock>

                <InputField field="useExistingAddress"      label="Same as insured address"          intercept={ this.intercept.bind(this) }/>
                <InputField field="postalAddress"           label="Billing Address" size="col-md-6"         enabled={ !fields.useExistingAddress }/>
                <div className="col-12"/>
                <InputField field="suburb"                  label="Suburb/Town"    size="col-md-6"         enabled={ !fields.useExistingAddress }  type="SuburbAuto"  stateField="state"  postcodeField="postcode"/>
                <InputField field="state"                   label="State"          size="col-3 col-md-3"   enabled={ false }/>
                <InputField field="postcode"                label="Postcode"       size="col-3 col-md-3"   enabled={ false } type="number"/>

                <Button.Container>
                    <Button.Continue onClick={ this.validate.bind(this) }>Buy</Button.Continue>
                </Button.Container>

            </div>
        )
    }


    validate(){
        this.props.actions.validation.validate( this.submit.bind(this) );
    }


    submit(){
        const endpoint = this.props.submission.endpoints.step6
        this.props.actions.submission.submit(endpoint, this.proceed.bind(this), [
            formConfig
        ] );
    }


    proceed(){
        this.props.actions.navigation.changeRoute("/payment")
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/contents/routes/step-6.tsx